module.exports = "<span class=\"span-link\" ng-click=\"$ctrl.showDialog($event)\">{{ $ctrl.text }}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/app/compare-modal/compare-modal.html
// module id = 872
// module chunks = 0